import React from 'react';
import { Button, Drawer, List } from 'antd';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { addMenu } from 'redux/slices/menu';
import { useNavigate } from 'react-router-dom';
import notificationService from 'services/notification';
import {
  SoundFilled,
  AudioMutedOutlined,
} from '@ant-design/icons'; // Add AudioMutedOutlined

export default function NotificationDrawer({
  handleClose,
  visible,
  list,
  readAll,
  loading,
  paginate,
  setPaginate,
  muted,
  toggleMute,
}) {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const { direction } = useSelector((state) => state.theme.theme, shallowEqual);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToShow = (id) => {
    let url = '';
    switch (user.role) {
      case 'admin':
        url = `order/details/${id}`;
        break;
      case 'manager':
        url = `order/details/${id}`;
        break;
      case 'seller':
        url = `seller/order/details/${id}`;
        break;
      case 'moderator':
        url = `seller/order/details/${id}`;
        break;
      case 'deliveryman':
        url = `deliveryman/order/details/${id}`;
        break;

      default:
        break;
    }
    dispatch(
      addMenu({
        url,
        id: 'order_details',
        name: t('order.details'),
      }),
    );
    navigate(`/${url}`);
  };
  const goToRefund = (refundId) => {
    try {
      let url = '';
      switch (user.role) {
        case 'admin':
          url = `refund/details/${refundId}`;
          break;
        case 'seller':
          url = `seller/refund/details/${refundId}`;
          break;
        default:
          url = `refund/details/${refundId}`;
          break;
      }
      dispatch(
        addMenu({
          url,
          id: 'refund_details',
          name: t('refund.details'),
        }),
      );
      navigate(`/${url}`);
    } catch (error) {
      debugger;
    }
  };

  const fetchReadAtNotification = (id) => {
    notificationService.readAt(id).then(() => { });
  };

  const goToProduct = (productUuid, notificationId) => {
    dispatch(
      addMenu({
        url: `product/${productUuid}`,
        id: 'product_edit',
        name: t('edit.product'),
      }),
    );
    navigate(`/product/${productUuid}?step=2&notif=${notificationId}`);
  };

  const handleClickNotification = (item) => {
    if (item?.model_type === 'order') {
      const orderId = item?.data?.id;
      const id = item?.id;
      handleClose();
      goToShow(orderId);
      fetchReadAtNotification(id);
    } else if (item?.model_type === 'orderrefund') {
      const refundId = item?.data?.id;
      const id = item?.id;
      handleClose();
      goToRefund(refundId);
      fetchReadAtNotification(id);
    } else if (item?.type === 'status_changed' && item?.model_type === 'product') {
      // Get UUID from model object (from full notification response) or from data
      const productUuid = item?.model?.uuid || item?.data?.uuid;
      const notificationId = item?.id;
      if (productUuid) {
        handleClose();
        goToProduct(productUuid, notificationId);
        fetchReadAtNotification(notificationId);
      }
    }
  };

  const handleReadAll = () => {
    readAll().finally(() => handleClose());
  };

  return (
    <Drawer
      title={t('notifications')}
      placement={direction === 'rtl' ? 'right' : 'left'}
      closable={true}
      open={visible}
      visible={visible}
      mask={true}
      maskClosable={true}
      onClose={handleClose}
      key={'notification-drawer'}
      zIndex={3000}
      getContainer={() => document.body}
      push={false}
      keyboard={true}
      destroyOnClose={true}
      motion={false}
      maskMotion={false}
      maskStyle={{ pointerEvents: 'auto', cursor: 'pointer' }}
      style={{ pointerEvents: 'auto' }}
      extra={<Button onClick={handleReadAll}>{t('read.all')}</Button>}
    >
      {/* Mute/Unmute button at the top left */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <Button
          icon={muted ? <AudioMutedOutlined /> : <SoundFilled />}
          onClick={toggleMute}
          style={{
            background: '#f0f0f0',
            borderColor: '#d9d9d9',
            color: '#595959',
            marginRight: 8,
          }}
          size="small"
        >
          {muted ? t('unmute') : t('mute')}
        </Button>
      </div>

      <List
        size='small'
        itemLayout='horizontal'
        dataSource={list}
        loading={loading}
        renderItem={(item) => (
          <List.Item
            className='list-clickable'
            onClick={() => handleClickNotification(item)}
          >
            <div
              className='py-1'
              style={{
                display: 'flex',
                alignItems: 'center',
                columnGap: '10px',
              }}
            >
              {!item?.read_at && (
                <span
                  style={{
                    display: 'block',
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    backgroundColor: 'tomato',
                  }}
                />
              )}
              <span className='font-weight-bold'>{item?.title}</span>
            </div>
          </List.Item>
        )}
      />
      <Button
        onClick={() => setPaginate({ page: paginate.page + 1 })}
        className='w-100 mt-4'
        type='primary'
        disabled={loading}
      >
        {t('load.more')}
      </Button>
    </Drawer>
  );
}
